import { createErrorReportingAsyncThunk } from "../../helpers";
import axios from "axios";
import { createSlice } from "@reduxjs/toolkit";
import { subcontractorsT, Subcontractors } from "./types";
import { getData, isAxiosError } from "../../../axios";
import * as tPromise from "io-ts-promise";

const prefix = "data/subcontractors";

type State = {
  subcontractors: Subcontractors;
};

const initialState: State = {
  subcontractors: [],
};

export const removeSubcontractor = createErrorReportingAsyncThunk(
  `${prefix}/remove-subcontractor`,
  async (input: { id: string; notifyContractor: boolean }) => {
    const { id, notifyContractor } = input;
    await axios.delete(
      `/api/subcontractors/${id}?notifyContractor=${notifyContractor}`
    );
  }
);

export const loadSubcontractors = createErrorReportingAsyncThunk(
  `${prefix}/get-subcontractors`,
  async () => {
    return axios
      .get("/api/subcontractors")
      .then(getData)
      .then(tPromise.decode(subcontractorsT));
  }
);

export const acceptInvitation = createErrorReportingAsyncThunk(
  `${prefix}/accept-invitation`,
  async (token: string) => {
    try {
      await axios.post(`/api/subcontractors/accept-invitation?token=${token}`)
      return "SUCCESS";
    } catch (err) {
      if (isAxiosError(err) && err.response?.status === 409) {
        return "ALREADY_ACCEPTED"
      }
      throw err;
    }
  }
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadSubcontractors.fulfilled, (state, action) => {
        state.subcontractors = action.payload;
      })
      .addCase(removeSubcontractor.fulfilled, (state, action) => {
        state.subcontractors = state.subcontractors.filter(
          (i) => i.id !== action.meta.arg.id
        );
      });
  },
});

export default slice.reducer;
